import moment from "moment-timezone";
import {
    apiCarBrandId,
    apiCarDescription,
    apiCarFuelTypeId,
    apiCarGprsId,
    apiCarGroupId,
    apiCarModelId,
    apiRegistrationNo,
    emptyDataResponse,
    sortAscending,
    sortDescending
} from './staticData';
import {useLocation} from 'react-router-dom';
import t from "../languages/pl";
import {tabsPanelHeight, toolbarHeight} from '../config/constants';

import grayClover from '../images/trophies/grayClover.svg';
import clover from '../images/trophies/clover.svg';
import bronzeStar from '../images/trophies/bronzeStar.svg';
import silverStar from '../images/trophies/silverStar.svg';
import goldStar from '../images/trophies/goldStar.svg';
import medal from '../images/trophies/medal.svg';
import trophy from '../images/trophies/trophy.svg';

export const trophyIcons = [grayClover, clover, bronzeStar, silverStar, goldStar, medal, trophy];

export const trophyDescriptions = [t.trophy0RankDescription, t.trophy1RankDescription, t.trophy2RankDescription,
    t.trophy3RankDescription, t.trophy4RankDescription, t.trophy5RankDescription, t.trophy6RankDescription];

export const themeTypeToBool = themeType => themeType === "light";

export const convertFromEpoch = epochDate => {
    let newDate = new Date(0);
    newDate.setUTCSeconds(epochDate);
    return newDate.getDate() + "." + (newDate.getMonth() + 1) + "." + newDate.getFullYear();
};

export const convertMomentEpoch = epochDate => moment.unix(epochDate);

export const evaluateEcoGradeTrend = grade => (grade > 5) ? "up" : "down";

export const convertPositions = positions => {
    if (positions) {
        if (Array.isArray(positions)) {
            return positions.map(position => [position.lat, position.lon]);
        }
        return [positions.lat, positions.lon];
    }
};

export const getRoutesOfType = (routes, type) => {
    if (!routes)
        return [];
    return routes.filter(route => route.type === type);
};

export const calcDurationFromEpoch = (begin, end) => {
    let start = moment.unix(begin);
    let finish = moment.unix(end);
    return moment.duration(finish.diff(start));
};

export const setGradeColor = (grade) => {
    if (grade > 0 && grade <= 2)
        return "#fccccc";
    else if (grade > 2 && grade <= 4)
        return "#ffbc85";
    else if (grade > 4 && grade <= 6)
        return "#FFB901";
    else if (grade > 6 && grade <= 8)
        return "#d6ef2f";
    else if (grade > 8)
        return "#69E4A6";
    else return "transparent";
};

export const getTrophyIcon = (rank) => {
    if (trophyIcons[rank])
        return trophyIcons[rank];
    return null;
};

export const getTrophyDescription = (rank) => {
    if (trophyDescriptions[rank])
        return trophyDescriptions[rank];
    return t.noDescriptionForTrophy;
};

export const selectTrophySize = (classes, trophyIconNumber) => {
    if (trophyIconNumber === 0)
        return classes.noTrophyIcon;
    if (trophyIconNumber === 1)
        return classes.smallTrophyIcon;
    if (trophyIconNumber < 5)
        return classes.mediumTrophyIcon;
    if (trophyIconNumber === 5)
        return classes.bigTrophyIcon;
    if (trophyIconNumber === 6)
        return classes.bestTrophyIcon;
    return classes.bestTrophyIcon;
};

export const selectCellByTrophyCount = (classes, trophyIconNumber) => {
    if (trophyIconNumber >= 5)
        return classes.medalIconCell;
    if (trophyIconNumber < 5 && trophyIconNumber >= 2)
        return classes.starIconCell;
    if (trophyIconNumber < 2)
        return classes.iconCell;
    return classes.iconCell;
};

const handleGroupFilter = (cars, filter) => {
    if (filter !== null && Object.keys(filter).length > 0) {
        return cars.filter(car => {
            let filteredCar = car.grupy.filter(group => group[apiCarGroupId] === filter.id);
            if (filteredCar.length > 0)
                return car;
        });
    }
    return cars;
};

export const handleFilter = (cars, filter, criteria) => {
    if (filter !== null && Object.keys(filter).length > 0) {
        return cars.filter(car => car[criteria] === filter.id);
    }

    return cars;
};

export const handleFilters = (cars, groupFilter, brandFilter, modelFilter, fuelTypeFilter) => {
    let filteredCars = handleGroupFilter(cars, groupFilter);
    filteredCars = handleFilter(filteredCars, brandFilter, apiCarBrandId);
    filteredCars = handleFilter(filteredCars, modelFilter, apiCarModelId);
    filteredCars = handleFilter(filteredCars, fuelTypeFilter, apiCarFuelTypeId);
    return filteredCars;
};

export const handleSearchPhrase = (cars, phrase, registrationNo, description) => {
    if (phrase !== null && Object.keys(phrase).length > 0)
        cars = cars.filter(car => car[registrationNo].toLowerCase().includes(phrase.toLowerCase())
            || car[description].toLowerCase().includes(phrase.toLowerCase()));
    return cars;
};

export const handleFiltersCarList = (cars, groupFilter, brandFilter, modelFilter, fuelTypeFilter, gprsFilter, phrase) => {
    let filteredCars = handleGroupFilter(cars, groupFilter);
    filteredCars = handleSearchPhrase(filteredCars, phrase, apiRegistrationNo, apiCarDescription);
    filteredCars = handleFilter(filteredCars, brandFilter, apiCarBrandId);
    filteredCars = handleFilter(filteredCars, modelFilter, apiCarModelId);
    filteredCars = handleFilter(filteredCars, fuelTypeFilter, apiCarFuelTypeId);
    filteredCars = handleGprsFilter(filteredCars, gprsFilter, apiCarGprsId);

    return filteredCars;
};

export const handleGprsFilter = (cars, filter, criteria) => {
    if (filter !== null && Object.keys(filter).length > 0)
        return cars.filter(car => car[criteria] === filter.name);
    return cars;
};

export const handleFiltersCarListByRegistration = (cars, groupFilter, brandFilter, modelFilter, fuelTypeFilter, phrase) => {
    let filteredCars = handleGroupFilter(cars, groupFilter);
    filteredCars = handleSearchRegistrationByPhrase(filteredCars, phrase, apiRegistrationNo);
    filteredCars = handleFilter(filteredCars, brandFilter, apiCarBrandId);
    filteredCars = handleFilter(filteredCars, modelFilter, apiCarModelId);
    filteredCars = handleFilter(filteredCars, fuelTypeFilter, 'id');

    return filteredCars;
};

export const handleSearchRegistrationByPhrase = (cars, phrase, registrationNo) => {
    if (phrase !== null && Object.keys(phrase).length > 0) {
        cars = cars.filter(car => car[registrationNo].toLowerCase().includes(phrase.toLowerCase()));
    }

    return cars;
};


export const baseCarsSearchByFilters = (carsList, phrase, groupId, brandId, modelId, fuelTypeId) => {
    return carsList
        .filter(car => car.rejestracja.toLowerCase().includes(phrase.toLowerCase()))
        .filter(car => groupId ? car.grupy.some(g => g.grupa_id === groupId) : true)
        .filter(car => brandId ? car.marka_id === brandId : true)
        .filter(car => modelId ? car.model_id === modelId : true)
        .filter(car => fuelTypeId ? car.paliwo_id === fuelTypeId : true);
};

export function isNullOrEmpty(str) {
    return (!str || 0 === str.length);
}

export function notArrayOrEmpty(array) {
    return !Array.isArray(array) || array.length === 0;
}

export function isEmail(email) {
    return String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
}

export function canBePhoneNumber(number) {
    let pattern = /^\+48\d{0,9}$/;
    return pattern.test(number);
}

export function isPhoneNumber(number) {
    let pattern = /^\+48(\s|-)?\d{9}$/;
    return pattern.test(number);
}

export function isPassword(password) {
    let pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$^+=!*()@%&]).{8,}$/;
    return pattern.test(password);
}

export function isQsafePrefix(prefix, username) {
    let pattern = new RegExp(`^${prefix}\\.?\\S+`);
    return pattern.test(username);
}

export function isNumberHasPolishPrefix(number) {
    let pattern = /^\+48/;
    return pattern.test(number);
}

export function isRfid(text) {
    let pattern = /^[a-zA-Z0-9]{10}$/;
    return pattern.test(text);
}

export function useQuery() {
    return new URLSearchParams(useLocation().search);
}

export function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export const sortByKey = (data, order, key) => {
    if (notArrayOrEmpty(data))
        return data;
    let sorted = data;
    if (order === sortAscending)
        sorted = data.sort((a, b) => {
            if (b[key] === emptyDataResponse)
                return 0;
            return a[key] - b[key];
        });
    else if (order === sortDescending)
        sorted = data.sort((a, b) => {
            if (b[key] === emptyDataResponse)
                return 0;
            return b[key] - a[key];
        });
    return sorted;
};

export const sortByRegistration = (data, order, key) => {
    if (notArrayOrEmpty(data))
        return data;
    let sorted = data;
    if (order === sortAscending)
        sorted = data.sort((a, b) => a[key].localeCompare(b[key]));
    else if (order === sortDescending)
        sorted = sorted = data.sort((a, b) => b[key].localeCompare(a[key]));
    return sorted;
};

export const getLastAverage = array => {
    if (notArrayOrEmpty(array))
        return;
    let lastValue = array[array.length - 1];
    return lastValue.srednia_eco ? lastValue.srednia_eco : t.noDataInfo;
};

export function areObjectsSame(obj1, obj2) {
    return JSON.stringify(obj1) === JSON.stringify(obj2);
}

export const convertLngToLon = (coords) => ({lat: coords.lat, lon: coords.lng});

export const selectConditionDescription = (id) => {
    if (id === 7) return t.neededPossibilityUploadingFile;
    else if (id === 25) return t.requiredSetStartingHoursAndMinutesOfWorkBeginning;
    else if (id === 26) return t.requiredSpecificationOfTheLengthOfTheStopInHoursAndTheStartAndEndOfWorkingHours;
    else if (id === 30) return t.requiredSetKmLimit;
    else return t.requiredSpecificationOfTheLengthOfTheStopInHoursAndTheStartAndEndOfWorkingHours;
};

export const countHeightWhen2HeightToolbarUsed = (height) => {
    return height - toolbarHeight - tabsPanelHeight - 6 * 8;
};
